import { Injectable } from '@angular/core';
import { NavigationDropdown, NavigationItem, NavigationLink, NavigationSubheading } from '../interfaces/navigation-item.interface';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { HistoryService } from './history.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {


  items: NavigationItem[] = [];

  //breadcrumbs code
  menuItems: any[] = [];
  crumbs: any[] = [];
  currentRoute: any;
  //breadcrumbs code

  private _openChangeSubject = new Subject<NavigationDropdown>();
  openChange$ = this._openChangeSubject.asObservable();

  constructor(private http: HttpClient,
    private historyService: HistoryService,
    private router: Router,
  ) {

  }

  triggerOpenChange(item: NavigationDropdown) {
    this._openChangeSubject.next(item);

  }

  isLink(item: NavigationItem): item is NavigationLink {
    return item && !!(item as NavigationLink).route;
  }

  isDropdown(item: NavigationItem): item is NavigationDropdown {
    return item && !!(item as NavigationDropdown).children;
  }

  isSubheading(item: NavigationItem): item is NavigationSubheading {
    return !this.isLink(item) && !this.isDropdown(item);
  }

  //breadcrumbs code
  updateCrumbs(item) {
    let dashboardObj = this.menuItems.find((obj) => { return obj.menuName == "Dashboard" });
    if (dashboardObj == undefined) {
      this.menuItems.push({ menuName: "Dashboard", route: "/layout/dashboards/analytics" })
    }
    this.crumbs = [];
    this.menuItems.forEach(menuItem1 => {
      if (menuItem1.menuName == item.menuName) {
        this.crumbs.push(menuItem1.menuName);
      } else {
        menuItem1.menuItems && menuItem1.menuItems.length > 0 && menuItem1.menuItems.forEach(menuItem2 => {
          if (menuItem2.menuName == item.menuName) {
            this.crumbs.push(menuItem1.menuName);
            this.crumbs.push(menuItem2.menuName);
          } else {
            menuItem2.menuItems && menuItem2.menuItems.length > 0 && menuItem2.menuItems.forEach(menuItem3 => {
              if (menuItem3.menuName == item.menuName) {
                this.crumbs.push(menuItem1.menuName);
                this.crumbs.push(menuItem2.menuName);
                this.crumbs.push(menuItem3.menuName);
              } else {
                menuItem3.menuItems && menuItem3.menuItems.length > 0 && menuItem3.menuItems.forEach(menuItem4 => {
                  if (menuItem4.menuName == item.menuName) {
                    this.crumbs.push(menuItem1.menuName);
                    this.crumbs.push(menuItem2.menuName);
                    this.crumbs.push(menuItem3.menuName);
                    this.crumbs.push(menuItem4.menuName);
                  } else {
                    menuItem4.menuItems && menuItem4.menuItems.length > 0 && menuItem4.menuItems.forEach(menuItem5 => {
                      if (menuItem5.menuName == item.menuName) {
                        this.crumbs.push(menuItem1.menuName);
                        this.crumbs.push(menuItem2.menuName);
                        this.crumbs.push(menuItem3.menuName);
                        this.crumbs.push(menuItem4.menuName);
                        this.crumbs.push(menuItem5.menuName);
                      } else {
                        menuItem5.menuItems && menuItem5.menuItems.length > 0 && menuItem5.menuItems.forEach(menuItem6 => {
                          if (menuItem6.menuName == item.menuName) {
                            this.crumbs.push(menuItem1.menuName);
                            this.crumbs.push(menuItem2.menuName);
                            this.crumbs.push(menuItem3.menuName);
                            this.crumbs.push(menuItem4.menuName);
                            this.crumbs.push(menuItem5.menuName);
                            this.crumbs.push(menuItem6.menuName);
                          } else {
                            menuItem6.menuItems && menuItem6.menuItems.length > 0 && menuItem6.menuItems.forEach(menuItem7 => {
                              if (menuItem7.menuName == item.menuName) {
                                this.crumbs.push(menuItem1.menuName);
                                this.crumbs.push(menuItem2.menuName);
                                this.crumbs.push(menuItem3.menuName);
                                this.crumbs.push(menuItem4.menuName);
                                this.crumbs.push(menuItem5.menuName);
                                this.crumbs.push(menuItem6.menuName);
                                this.crumbs.push(menuItem7.menuName);
                              }
                            });
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    });
  }
  getQuickMenuSettings(Service: string) {
    try {
      return this.http.get<any>(
        "/assets/json/Design/QuickMenu/" + Service + ".json"
      );
    } catch (ex) {
      return null;
    }
  }
  historyData: any[] = [];

  updatedCrumbs(route) {
    const path = this.router.url.split('/');
    const actualPath = path[path.length - 1].split('?');
    this.getQuickMenuSettings('submenu').subscribe(quickMenuList => {
      this.menuItems = quickMenuList;

      this.crumbs = [];
      this.menuItems.forEach(menuItem1 => {
        if (menuItem1.route == route) {
          this.currentRoute = menuItem1;
          this.crumbs.push(menuItem1.menuName);
        } else {
          menuItem1.menuItems && menuItem1.menuItems.length > 0 && menuItem1.menuItems.forEach(menuItem2 => {
            if (menuItem2.route == route) {
              this.currentRoute = menuItem2;
              this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
              this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
            } else {
              menuItem2.menuItems && menuItem2.menuItems.length > 0 && menuItem2.menuItems.forEach(menuItem3 => {
                if (menuItem3.route == route) {
                  this.currentRoute = menuItem3;
                  this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
                  this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
                  this.crumbs.push({ item: menuItem3.menuName, path: menuItem3.route });
                } else {
                  menuItem3.menuItems && menuItem3.menuItems.length > 0 && menuItem3.menuItems.forEach(menuItem4 => {
                    if (menuItem4.route == route) {
                      this.currentRoute = menuItem4;
                      this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
                      this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
                      this.crumbs.push({ item: menuItem3.menuName, path: menuItem3.route });
                      this.crumbs.push({ item: menuItem4.menuName, path: menuItem4.route });
                    } else {
                      menuItem4.menuItems && menuItem4.menuItems.length > 0 && menuItem4.menuItems.forEach(menuItem5 => {
                        if (menuItem5.route == route) {
                          this.currentRoute = menuItem5;
                          this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
                          this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
                          this.crumbs.push({ item: menuItem3.menuName, path: menuItem3.route });
                          this.crumbs.push({ item: menuItem4.menuName, path: menuItem4.route });
                          this.crumbs.push({ item: menuItem5.menuName, path: menuItem5.route });
                        } else {
                          menuItem5.menuItems && menuItem5.menuItems.length > 0 && menuItem5.menuItems.forEach(menuItem6 => {
                            if (menuItem6.route == route) {
                              this.currentRoute = menuItem6;
                              this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
                              this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
                              this.crumbs.push({ item: menuItem3.menuName, path: menuItem3.route });
                              this.crumbs.push({ item: menuItem4.menuName, path: menuItem4.route });
                              this.crumbs.push({ item: menuItem5.menuName, path: menuItem5.route });
                              this.crumbs.push({ item: menuItem6.menuName, path: menuItem5.route });
                            } else {
                              menuItem6.menuItems && menuItem6.menuItems.length > 0 && menuItem6.menuItems.forEach(menuItem7 => {
                                if (menuItem7.route == route) {
                                  this.currentRoute = menuItem7;
                                  this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
                                  this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
                                  this.crumbs.push({ item: menuItem3.menuName, path: menuItem3.route });
                                  this.crumbs.push({ item: menuItem4.menuName, path: menuItem4.route });
                                  this.crumbs.push({ item: menuItem5.menuName, path: menuItem5.route });
                                  this.crumbs.push({ item: menuItem6.menuName, path: menuItem5.route });
                                  this.crumbs.push({ item: menuItem7.menuName, path: menuItem7.route });
                                } else {
                                  menuItem7.menuItems && menuItem7.menuItems.length > 0 && menuItem7.menuItems.forEach(menuItem8 => {
                                    if (menuItem8.route == route) {
                                      this.currentRoute = menuItem8;
                                      this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
                                      this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
                                      this.crumbs.push({ item: menuItem3.menuName, path: menuItem3.route });
                                      this.crumbs.push({ item: menuItem4.menuName, path: menuItem4.route });
                                      this.crumbs.push({ item: menuItem5.menuName, path: menuItem5.route });
                                      this.crumbs.push({ item: menuItem6.menuName, path: menuItem5.route });
                                      this.crumbs.push({ item: menuItem7.menuName, path: menuItem7.route });
                                      this.crumbs.push({ item: menuItem8.menuName, path: menuItem8.route });
                                    }
                                  });
                                }
                              });
                            }

                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });

      this.historyService.updateHistory();
      this.historyService.getHistory().subscribe((res: any) => {
        this.historyData = res;
      });
      const duplicateCrumbs = this.crumbs;
      for (let i = 0; i < this.crumbs.length; i++) {
        for (let j = 0; j < this.historyData.length; j++) {
          if (this.crumbs[i].path == this.historyData[j].url) {
            duplicateCrumbs[i].path = this.historyData[j].actualUrl;
          }
        }
      }
      this.crumbs = duplicateCrumbs;
    });

  }

  updateCrumbsByRoute(route, fromCustom?: boolean) {
    if (fromCustom) {
      // onboarding code    
      this.crumbs = [];
      if (route + "" == "general-information") {
        this.crumbs.push("Providers Onboarding");
        this.crumbs.push("General Information");
      } else if (route + "" == "fill-in-questionnaire") {
        this.crumbs.push("Providers Onboarding");
        this.crumbs.push("Questionnaire");
      } else if (route + "" == "confirm-service-pricing") {
        this.crumbs.push("Providers Onboarding");
        this.crumbs.push("Confirm Service Pricing");
      } else if (route + "" == "mpm-search-provider" || route + "" == "mpm-search-provider?rtl=false" || route + "" == "mpm-search-provider?rtl=true") {
        this.crumbs.push("Providers Onboarding");
        this.crumbs.push("Search");
      }
    } else {
      let dashboardObj = this.menuItems.find((obj) => { return obj.menuName == "Dashboard" });
      if (dashboardObj == undefined) {
        this.menuItems.push({ menuName: "Dashboard", route: "/layout/dashboards/analytics" })
      }
      this.crumbs = [];
      this.menuItems.forEach(menuItem1 => {
        if (menuItem1.route == route) {
          this.currentRoute = menuItem1;
          // localStorage.setItem("currentRoute", JSON.stringify(menuItem1));
          this.crumbs.push(menuItem1.menuName);
        } else {
          menuItem1.menuItems && menuItem1.menuItems.length > 0 && menuItem1.menuItems.forEach(menuItem2 => {
            if (menuItem2.route == route) {
              this.currentRoute = menuItem2;
              // localStorage.setItem("currentRoute", JSON.stringify(menuItem2));
              this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
              this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
            } else {
              menuItem2.menuItems && menuItem2.menuItems.length > 0 && menuItem2.menuItems.forEach(menuItem3 => {
                if (menuItem3.route == route) {
                  this.currentRoute = menuItem3;
                  // localStorage.setItem("currentRoute", JSON.stringify(menuItem3));
                  this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
                  this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
                  this.crumbs.push({ item: menuItem3.menuName, path: menuItem3.route });
                } else {
                  menuItem3.menuItems && menuItem3.menuItems.length > 0 && menuItem3.menuItems.forEach(menuItem4 => {
                    if (menuItem4.route == route) {
                      this.currentRoute = menuItem4;
                      // localStorage.setItem("currentRoute", JSON.stringify(menuItem4));
                      this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
                      this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
                      this.crumbs.push({ item: menuItem3.menuName, path: menuItem3.route });
                      this.crumbs.push({ item: menuItem4.menuName, path: menuItem4.route });
                    } else {
                      menuItem4.menuItems && menuItem4.menuItems.length > 0 && menuItem4.menuItems.forEach(menuItem5 => {
                        if (menuItem5.route == route) {
                          this.currentRoute = menuItem5;
                          // localStorage.setItem("currentRoute", JSON.stringify(menuItem5));
                          this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
                          this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
                          this.crumbs.push({ item: menuItem3.menuName, path: menuItem3.route });
                          this.crumbs.push({ item: menuItem4.menuName, path: menuItem4.route });
                          this.crumbs.push({ item: menuItem5.menuName, path: menuItem5.route });
                        } else {
                          menuItem5.menuItems && menuItem5.menuItems.length > 0 && menuItem5.menuItems.forEach(menuItem6 => {
                            if (menuItem6.route == route) {
                              this.currentRoute = menuItem6;
                              // localStorage.setItem("currentRoute", JSON.stringify(menuItem6));
                              this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
                              this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
                              this.crumbs.push({ item: menuItem3.menuName, path: menuItem3.route });
                              this.crumbs.push({ item: menuItem4.menuName, path: menuItem4.route });
                              this.crumbs.push({ item: menuItem5.menuName, path: menuItem5.route });
                              this.crumbs.push({ item: menuItem6.menuName, path: menuItem6.route });
                            } else {
                              menuItem6.menuItems && menuItem6.menuItems.length > 0 && menuItem6.menuItems.forEach(menuItem7 => {
                                if (menuItem7.route == route) {
                                  this.currentRoute = menuItem7;
                                  // localStorage.setItem("currentRoute", JSON.stringify(menuItem7));
                                  this.crumbs.push({ item: menuItem1.menuName, path: menuItem1.route });
                                  this.crumbs.push({ item: menuItem2.menuName, path: menuItem2.route });
                                  this.crumbs.push({ item: menuItem3.menuName, path: menuItem3.route });
                                  this.crumbs.push({ item: menuItem4.menuName, path: menuItem4.route });
                                  this.crumbs.push({ item: menuItem5.menuName, path: menuItem5.route });
                                  this.crumbs.push({ item: menuItem6.menuName, path: menuItem6.route });
                                  this.crumbs.push({ item: menuItem7.menuName, path: menuItem7.route });
                                }
                              });
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
  }
  //breadcrumbs code
}
